import { css } from "@emotion/react";

import { colors, animations, dimensions } from "@styles/index";

export const socialLinksWrapper = css`
  @media (min-width: ${dimensions.desktop}) {
    margin-top: 1.25rem;
  }
`;

export const socialLinks = css`
  display: flex;
  margin-bottom: 2rem;
  @media (hover: none) {
    li {
      height: 5rem;
      width: 5rem;
    }
  }

  li a {
    ${animations.transition()};
    color: ${colors.white};
    margin-right: 1.75rem;

    &:hover {
      color: ${colors.green.base};
    }
  }
`;
